import axios from 'axios';
const CONTROLLER_PATH = 'Discipline';
class DisciplineService {
    //CREATE

    //READ
    get() {
        return axios.get(CONTROLLER_PATH).then((response) => response.data);
    }

    //UPDATE

    //DELETE
}

export default new DisciplineService();
